import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsGithub } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";

function ProjectCards({ project }) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={project.image} alt={project.title} />

      <Card.Body>
        <Card.Title>{project.title}</Card.Title>

        <Card.Text style={{ textAlign: "justify" }}>
          {project.description}
        </Card.Text>

        {/* Github */}

        {project.github && (
          <Button variant="primary" href={project.github} target="_blank">
            <BsGithub /> GitHub
          </Button>
        )}

        {/* Detail */}

        <Button
          variant="primary"
          href={project.detail}
          style={{ marginLeft: "10px" }}
        >
          <CgWebsite /> Detail
        </Button>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
